import { parseSearchWith } from '@tanstack/react-router'

/**
 * Same JSON-per-key search codec the router is configured with in App.tsx.
 * Post-login redirects must decode search params with this codec: rebuilding
 * them from URLSearchParams yields raw strings ("1", "[]"), which the router's
 * stringifySearch then re-encodes quoted (pageNumber=%221%22) so routes with
 * typed search schemas (e.g. /documents pageNumber: z.number()) reject the
 * link after login.
 */
const parseSearch = parseSearchWith(JSON.parse)

/**
 * Splits a post-login return URL into `navigate()` arguments, preserving the
 * types of search params. `basePath` is stripped from the pathname so the
 * router (which is already mounted under it) doesn't see it twice.
 */
export function navigationFromReturnTo(
  returnTo: string,
  basePath: string
): { to: string; search: Record<string, unknown> } {
  const url = new URL(returnTo, window.location.origin)
  return {
    to: basePath ? url.pathname.replace(basePath, '') : url.pathname,
    search: parseSearch(url.search),
  }
}
